import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../services/modal.service';
import { I18nTranslator } from '../../i18n/translate';
import { FieldviewService } from '../../services/fieldview.service';
import { KeycloakService } from '../../services/keycloak.service';
import { UserService } from '../../services/user.service';
import { FIELDVIEW_API_OAUTH_URL } from '../../utils/env';
import { Organisation } from '../../models/organisation.model';
import { OrganisationService } from '../../services/organisation.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  standalone: true,
  selector: 'fieldview-link-button',
  templateUrl: 'fieldview-link-button.component.html',
  providers: [UserService, FieldviewService, OrganisationService],
  imports: [CommonModule, TranslatePipe],
})
export class FieldviewLinkButton implements OnInit {
  showLinkField: boolean = false;
  userLink: boolean = false;
  roleAccess = ['ROLE_FARMER', 'ROLE_ADVISOR'];

  // limites sur le distributeur et la marque blanche via FIELDVIEW_API_OAUTH_URL : peu clair, à reprendre
  organisationsCanOrderFW = [
    308, 328, 329, 330, 331, 122, 90, 250, 87, 264, 299, 320, 42, 223, 304, 172, 286, 1, 342, 311, 288, 270, 333, 290,
    123, 321, 242, 218, 315,
  ];
  canUserOrderFW: boolean = false;

  constructor(
    private secureLink: FieldviewService,
    private userService: UserService,
    private i18nTranslator: I18nTranslator,
    private modal: ModalService,
  ) {
    // membership, not realmAccess.roles[0]: the claim order is not guaranteed (C2027-182)
    const canLink = KeycloakService.platformRoles().some((role) => this.roleAccess.includes(role));
    if (FIELDVIEW_API_OAUTH_URL != '' && canLink) {
      this.showLinkField = true;
      secureLink.getFieldviewUser().subscribe((data: any) => {
        if (data && data.link == true) {
          this.userLink = true;
        }
      });
    }
  }

  ngOnInit() {
    this.getOrganisation().subscribe((organisation) => {
      this.handleShowFW(organisation);
    });
  }

  getOrganisation(): Observable<Organisation> {
    return this.userService.getMe().pipe(map((me) => me.organisation));
  }

  handleShowFW(organisation: Organisation) {
    if (this.organisationsCanOrderFW.includes(organisation.id)) {
      this.canUserOrderFW = true;
    }
  }

  linkAccount() {
    this.secureLink.redirectToFieldviewAuth();
  }

  deleteLink() {
    this.secureLink.deleteFieldviewUser().subscribe(
      (x) => {
        this.userLink = false;
        this.modal.alert(this.i18nTranslator.translate('fieldview.disconnect.success'));
      },
      (err) => {
        console.log(err);
        this.modal.alert(this.i18nTranslator.translate('fieldview.disconnect.error'));
      },
    );
  }
}
